import {useTranslation} from 'next-i18next';
import {memo, useMemo} from 'react';

import IconSertificate from '@/public/images/signup/benefitsIcon/certificated.svg';
import IconFreeTrial from '@/public/images/signup/benefitsIcon/free-trial.svg';
import IconNoCard from '@/public/images/signup/benefitsIcon/no-card.svg';
import IconQuality from '@/public/images/signup/benefitsIcon/quality.svg';
import BenefitsListItem, {
  BenefitsListItemProps,
} from '@/src/signUp/layoutSingUp/componetns/BenefitsListItem';

import css from '../styles/BenefitsList.module.css';

const getBenefitsList = (t: Function): Array<BenefitsListItemProps> => {
  return [
    {
      title: t('sing-up-benefits.secrificated'),
      icon: <IconSertificate />,
    },
    {
      title: t('sing-up-benefits.quality'),
      icon: <IconQuality />,
    },
    {
      title: t('sing-up-benefits.trial'),
      icon: <IconFreeTrial />,
    },
    {
      title: t('sing-up-benefits.no-card'),
      icon: <IconNoCard />,
    },
  ];
};

const BenefitsList = () => {
  const {t} = useTranslation('common');

  const benefits: Array<BenefitsListItemProps> = useMemo(
    () => getBenefitsList(t),
    [t]
  );

  const benefitsJSX = useMemo(
    () =>
      benefits.map(({title, icon}) => (
        <div key={title} className={css.benefit}>
          <BenefitsListItem title={title} icon={icon} />
        </div>
      )),
    [benefits]
  );

  return <div className={css.benefitList}>{benefitsJSX}</div>;
};

export default memo(BenefitsList);
